// ** Redux
import { useSelector, useDispatch } from "react-redux";
import { setSharedGalleryViewType } from "store/modules/global-view-types.slice";

// #####################################################

export const useSharedGalleryViewType = () => {
	const dispatch = useDispatch();
	const sharedGalleryViewType = useSelector(
		(state) => state.globalViewTypes.sharedGalleryViewType
	);

	const handleViewType = (viewType) => {
		dispatch(setSharedGalleryViewType(viewType));
		return viewType;
	};

	return {
		handleViewType,
		viewType: sharedGalleryViewType,
	};
};
